<template>
  <v-card :class="{ 'mb-4': !removeMb }" :outlined="$vuetify.theme.dark">
    <slot name="top"></slot>
    <v-list color="cardSurface" class="py-0">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="headerShowAll">
            <v-skeleton-loader
              v-if="loading"
              type="heading"
            ></v-skeleton-loader>
            <h3 v-else class="primary--text headline font-weight-bold">
              {{ title }}
            </h3>
          </v-list-item-title>
        </v-list-item-content>

        <slot name="dialogBtn"></slot>
      </v-list-item>
      <v-divider v-if="!removeDivider"></v-divider>
      <v-subheader v-if="subheader">{{ subheader }}</v-subheader>
      <slot></slot>
    </v-list>
  </v-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    subheader: {
      type: String,
    },
    removeMb: {
      type: Boolean,
      default: false,
    },
    removeDivider: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.headerShowAll {
  white-space: inherit;
}
</style>
